import React, { useEffect, useState } from 'react'
import { Form, FormGroup, Label, Input, Card, CardBody, Row, Col, CardFooter, CustomInput } from 'reactstrap'
import FalconCardHeader from '../common/FalconCardHeader'
import WizardError from '../auth/register/WizardError';
import classNames from 'classnames';
import ButtonIcon from '../common/ButtonIcon';
import { useForm } from 'react-hook-form';
import NumberFormat from 'react-number-format';
import { faUndo } from '@fortawesome/free-solid-svg-icons';
import { useParams } from 'react-router';
import withRedirect from '../../helpers/hoc/withRedirect';
import { PreloadState } from '../UI/preloading/PreloadState';
import moment from 'moment';
import useModuleBase from "../../helpers/hooks/useModuleBase";
const CreateDebtReceivableForm = ({ debttopay, handleSubmitData, setRedirect, setRedirectUrl }) => {

    const moduleBase = useModuleBase();

    const { id } = useParams();
    const [price, setPrice] = useState(null);
    const [isSpecial, setIsSpecial] = useState(false);
    const { register, handleSubmit, formState: { isSubmitting, errors }, setValue, setError, clearErrors } = useForm(
        {
            mode: 'onChange',
            reValidateMode: 'onChange',
            shouldFocusError: true,
            shouldUnregister: false
        }
    );

    useEffect(() => {
        if (debttopay) {
            register('price');
            setValue('price', debttopay.price);
            setPrice(debttopay.price);
            if (debttopay.expires_at) {
                setIsSpecial(true);
            }
        }
        // eslint-disable-next-line
    }, [debttopay])

    useEffect(() => {
        if (!isSpecial) {
            setValue('expires_at', null);
        }
        // eslint-disable-next-line
    }, [isSpecial])

    useEffect(() => {
        setValue('price', price);
        if (!price) {
            setError('price', { message: 'Ingrese un monto válido.' })
        } else {
            clearErrors('price');
        }
        // eslint-disable-next-line
    }, [price])

    const renderForm = () => {
        return <>
            <FalconCardHeader title="Detalle de Efecto por cobrar" light={false} />
            <CardBody>
                <Row form>
                    <Col sm tag={FormGroup}>
                        <Label for="identification">Nombre de la cuenta a cobrar</Label>
                        <Input
                            autoComplete="off"
                            name="name"
                            id="name"
                            defaultValue={debttopay?.name}
                            className={classNames({ 'border-danger': errors['name']?.message })}
                            placeholder="Nombre"
                            innerRef={register({
                                required: 'El nombre es requerida.',
                                minLength: { value: 5, message: 'El nombre del efecto por cobrar debe ser igual o mayor a 5 caracteres.' },
                                pattern: {
                                    value: /^[a-z A-Z0-9_-]+$/i,
                                    message: 'Solo se aceptan alphanúmericos.'
                                }
                            })}
                        />
                        <WizardError error={errors['name']?.message} className="fs--1 font-weight-normal d-block" />
                    </Col>
                    <Col sm tag={FormGroup}>
                        <Label for="acronym">Monto</Label>
                        <NumberFormat fixedDecimalScale={true} prefix='$ ' decimalScale={2} className={`${errors['price']?.message ? 'border-danger' : ''} form-control`} placeholder="Monto" value={price} onValueChange={({ value }) => { setPrice(value); }} thousandSeparator={true} renderText={(value, props) => <div {...props}>{value}</div>} />
                        <WizardError error={errors['price']?.message} className="fs--1 font-weight-normal d-block" />
                    </Col>
                </Row>
                <Row form>
                    <Col sm tag={FormGroup}>
                        <CustomInput
                            type="checkbox"
                            id="customCheck1"
                            label="¿Es una cuota especial?"
                            checked={isSpecial}
                            onChange={(event) => {
                                if (event.target.checked) {
                                    setIsSpecial(true);
                                } else {
                                    setIsSpecial(false);
                                }
                            }}
                            className="mb-0"
                        />
                    </Col>

                    {isSpecial && <Col sm tag={FormGroup}>
                        <Label for="acronym">Expira</Label>
                        <Input
                            autoComplete="off"
                            name="expires_at" id="expires_at"
                            defaultValue={debttopay?.expires_at ? moment(debttopay.expires_at).format('yyyy-MM-DD') : moment().format('YYYY-MM-DD')}
                            placeholder="Fecha de expiración"
                            type='date'
                            className={classNames({ 'border-danger': errors['expires_at']?.message })}
                            innerRef={register()} />
                        <WizardError error={errors['expires_at']?.message} className="fs--1 font-weight-normal d-block" />
                    </Col>}

                </Row>


                <Row form>
                    <Col sm>
                        <Label for="address">Descripción</Label>
                        <Input
                            id="description"
                            name="description"
                            defaultValue={debttopay?.description}
                            type="textarea"
                            rows={6}
                            placeholder="Ingrese una descripción del efecto por cobrar"
                            className={classNames({ 'border-danger': errors['description']?.message })}
                            innerRef={register({
                                required: 'La descripción es requerida.',
                                minLength: { value: 10, message: 'La descripción debe contener al menos 10 caracteres.' },
                            })} />
                        <WizardError error={errors['description']?.message} className="fs--1 font-weight-normal d-block" />
                    </Col>
                </Row>

            </CardBody>
            <CardFooter className={classNames('px-md-6 bg-light d-flex')}>
                <ButtonIcon
                    color="falcon-default"
                    className="ml-auto px-5 mr-2"
                    icon={faUndo}
                    onClick={() => {
                        setRedirectUrl(`/dashboard/${moduleBase}/${id}/receivable`);
                        setRedirect(true);
                    }}
                    iconAlign="right"
                    transform="down-1 shrink-4"
                >
                    Volver
                </ButtonIcon>
                <ButtonIcon
                    data-testid="submit-button"
                    color="primary"
                    className="px-5"
                    type="submit"
                    icon="save"
                    iconAlign="right"
                    disabled={(Object.keys(errors).length > 0)}
                    transform="down-1 shrink-4"
                >
                    Guardar
                </ButtonIcon>
            </CardFooter>
        </>
    }

    return <>
        <Card data-testid="form" className="mb-3 bg-light" tag={Form} onSubmit={handleSubmit(handleSubmitData)}>
            <PreloadState loading={isSubmitting} message='Guardando efecto por cobrar...'>
                {renderForm()}
            </PreloadState>
        </Card>
    </>
}


export default withRedirect(CreateDebtReceivableForm);